// extracted by mini-css-extract-plugin
export default {"label-style":"label_label-style__qGHqQ","main-label":"label_main-label__Moxb-","sub-content":"label_sub-content__0SG7w"};